import LeaveAdjustmentTypes from './LeaveAdjustment.types';

// ========== GET EMPLOYEE LEAVE BALANCE ACTIONS START ==========
export const getEmployeeLeaveBalanceStart = (data: any) => ({
	type: LeaveAdjustmentTypes.GET_EMPLOYEE_LEAVE_BALANCE_START,
	payload: data,
});

export const getEmployeeLeaveBalanceSuccess = (data: any) => ({
	type: LeaveAdjustmentTypes.GET_EMPLOYEE_LEAVE_BALANCE_SUCCESS,
	payload: data,
});

export const getEmployeeLeaveBalanceFailure = (error: unknown) => ({
	type: LeaveAdjustmentTypes.GET_EMPLOYEE_LEAVE_BALANCE_FAILURE,
	payload: error,
});
// ========== GET EMPLOYEE LEAVE BALANCE ACTIONS END ==========

// ========== CREATE LEAVE ADJUSTMENT ACTIONS START ==========
export const createLeaveAdjustmentStart = (data: any) => ({
	type: LeaveAdjustmentTypes.CREATE_LEAVE_ADJUSTMENT_START,
	payload: data,
});

export const createLeaveAdjustmentSuccess = (data: any) => ({
	type: LeaveAdjustmentTypes.CREATE_LEAVE_ADJUSTMENT_SUCCESS,
	payload: data,
});

export const createLeaveAdjustmentFailure = (error: unknown) => ({
	type: LeaveAdjustmentTypes.CREATE_LEAVE_ADJUSTMENT_FAILURE,
	payload: error,
});

export const createLeaveAdjustmentResponseReset = () => ({
	type: LeaveAdjustmentTypes.CREATE_LEAVE_ADJUSTMENT_RESPONSE_RESET,
});
// ========== CREATE LEAVE ADJUSTMENT ACTIONS END ==========

// ========== GET EMPLOYEE APPROVED LEAVES FOR YEAR ==========
export const getEmployeeApprovedLeavesForYearStart = (data: any) => ({
	type: LeaveAdjustmentTypes.GET_EMPLOYEE_APPROVED_LEAVES_FOR_YEAR_START,
	payload: data,
});
export const getEmployeeApprovedLeavesForYearSuccess = (data: any) => ({
	type: LeaveAdjustmentTypes.GET_EMPLOYEE_APPROVED_LEAVES_FOR_YEAR_SUCCESS,
	payload: data,
});
export const getEmployeeApprovedLeavesForYearFailure = (error: unknown) => ({
	type: LeaveAdjustmentTypes.GET_EMPLOYEE_APPROVED_LEAVES_FOR_YEAR_FAILURE,
	payload: error,
});

// ========== UPDATE APPLIED LEAVE ==========
export const updateAppliedLeaveStart = (data: any) => ({
	type: LeaveAdjustmentTypes.UPDATE_APPLIED_LEAVE_START,
	payload: data,
});
export const updateAppliedLeaveSuccess = (data: any) => ({
	type: LeaveAdjustmentTypes.UPDATE_APPLIED_LEAVE_SUCCESS,
	payload: data,
});
export const updateAppliedLeaveFailure = (error: unknown) => ({
	type: LeaveAdjustmentTypes.UPDATE_APPLIED_LEAVE_FAILURE,
	payload: error,
});
export const updateAppliedLeaveResponseReset = () => ({
	type: LeaveAdjustmentTypes.UPDATE_APPLIED_LEAVE_RESPONSE_RESET,
});

// ========== GET LEAVE EDIT HISTORY ==========
export const getLeaveEditHistoryStart = (data: any) => ({
	type: LeaveAdjustmentTypes.GET_LEAVE_EDIT_HISTORY_START,
	payload: data,
});
export const getLeaveEditHistorySuccess = (data: any) => ({
	type: LeaveAdjustmentTypes.GET_LEAVE_EDIT_HISTORY_SUCCESS,
	payload: data,
});
export const getLeaveEditHistoryFailure = (error: unknown) => ({
	type: LeaveAdjustmentTypes.GET_LEAVE_EDIT_HISTORY_FAILURE,
	payload: error,
});

// ========== GET LEAVE ADJUSTMENT HISTORY (tblLeaveAdjustment) ==========
export const getLeaveAdjustmentHistoryStart = (data: any) => ({
	type: LeaveAdjustmentTypes.GET_LEAVE_ADJUSTMENT_HISTORY_START,
	payload: data,
});
export const getLeaveAdjustmentHistorySuccess = (data: any) => ({
	type: LeaveAdjustmentTypes.GET_LEAVE_ADJUSTMENT_HISTORY_SUCCESS,
	payload: data,
});
export const getLeaveAdjustmentHistoryFailure = (error: unknown) => ({
	type: LeaveAdjustmentTypes.GET_LEAVE_ADJUSTMENT_HISTORY_FAILURE,
	payload: error,
});
export const leaveAdjustmentPageReset = () => ({
	type: LeaveAdjustmentTypes.LEAVE_ADJUSTMENT_PAGE_RESET,
});

